import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { ButtonLinkStyled } from "../Buttons/Button.Style";

import useWindowSize from "../../../hooks/useWindowSize";

import * as S from "./CoverageSection.style";

export const CoverageItem = ({ coverageItem }) => (
  <S.CoverageSectionItem key={coverageItem.id}>
    <S.CoverageSectionItemTitle>
      <coverageItem.icon /> <span>{coverageItem.title}</span>
    </S.CoverageSectionItemTitle>

    <S.CoverageSectionItemDescription>
      {coverageItem.description}
    </S.CoverageSectionItemDescription>
  </S.CoverageSectionItem>
);

CoverageItem.propTypes = {
  coverageItem: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      icon: PropTypes.elementType.isRequired,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ).isRequired,
};

CoverageItem.defaultProps = {};

const CoverageSection = ({ textsList, coverageList }) => {
  const itemRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(coverageList?.length ?? 4);
  const { width } = useWindowSize();

  const isMobile = width && width <= 760;
  const isShowButtoMoreItems = coverageList.length > 4;

  const isEnableMoreItems = Array.isArray(coverageList)
    ? visibleCount < coverageList.length
    : false;

  const currentBtnLabel = isEnableMoreItems ? "Mostrar mais" : "Mostrar menos";

  const scrollToMyRef = () => {
    itemRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  const handleClickMoreItems = useCallback(() => {
    if (isEnableMoreItems) {
      setVisibleCount(coverageList.length);
      return;
    }

    setVisibleCount(isMobile ? 2 : 4);
    scrollToMyRef();
  }, [isMobile, isEnableMoreItems, coverageList.length]);

  useEffect(() => {
    if (isMobile) {
      setVisibleCount(2);
    } else {
      setVisibleCount(4);
    }
  }, [isMobile]);

  return (
    <S.CoverageSectionContainer>
      <S.CoverageSectionContent className="container" ref={itemRef}>
        {Array.isArray(textsList)
          ? textsList.map((textItem) => (
              <S.CoverageSectionBlock key={textItem?.id}>
                <S.ConverageSectionBlockTitle>
                  {textItem?.title}
                </S.ConverageSectionBlockTitle>

                <S.ConverageSectionBlockDescription>
                  {textItem?.description}
                </S.ConverageSectionBlockDescription>
              </S.CoverageSectionBlock>
            ))
          : null}

        <S.CoverageSectionList>
          {Array.isArray(coverageList)
            ? coverageList
                .slice(0, visibleCount)
                .map((coverageItem) => (
                  <CoverageItem
                    key={coverageItem.id}
                    coverageItem={coverageItem}
                  />
                ))
            : null}
        </S.CoverageSectionList>

        {isShowButtoMoreItems ? (
          <S.CoverageSectionFooter>
            <ButtonLinkStyled type="button" onClick={handleClickMoreItems}>
              {currentBtnLabel}
            </ButtonLinkStyled>
          </S.CoverageSectionFooter>
        ) : null}
      </S.CoverageSectionContent>
    </S.CoverageSectionContainer>
  );
};

CoverageSection.propTypes = {
  textsList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
  coverageList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      icon: PropTypes.elementType.isRequired,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};

CoverageSection.defaultProps = {
  textsList: [],
  coverageList: [],
};

export default CoverageSection;
